// Mock data for Good-Bloom website

export const mockData = {
  // Hero section data
  hero: {
    title: "Good-Bloom — La dépollution aquatique éco-intelligente",
    subtitle: "Nos machines purifient les plans d'eau en capturant plastiques, nutriments et hydrocarbures.",
    ctaText: "Découvrir nos solutions",
    backgroundImage: "https://images.unsplash.com/photo-1596024463892-f5677f28e6d3"
  },

  // Technologies section data
  technologies: {
    title: "Nos Technologies",
    subtitle: "Systèmes autonomes de dépollution aquatique nouvelle génération",
    features: [
      {
        id: 1,
        title: "Installation sans travaux",
        description: "Filtration sans travaux 100% autonome",
        icon: "filter"
      },
      {
        id: 2,
        title: "Traitement Nutriments",
        description: "Élimination des nitrates et phosphates pour lutter contre l'eutrophisation",
        icon: "leaf"
      },
      {
        id: 3,
        title: "Absorption Hydrocarbures",
        description: "Technologies avancées de bioremédiation pour les pollutions pétrolières",
        icon: "droplets"
      },
      {
        id: 4,
        title: "Systèmes Autonomes",
        description: "Fonctionnement automatisé avec monitoring en temps réel",
        icon: "cpu"
      }
    ],
    processImage: 'Ressources/GoodBloom3.png', //"https://images.unsplash.com/photo-1674578745937-c73f81bdda07"
    ctaText: "Voir nos réalisations"
  },

  // Realizations section data
  realizations: {
    title: "Nos Réalisations",
    subtitle: "Découvrez nos projets de dépollution à travers la France",
    projects: [
      {
        id: 1,
        name: "Port de Saint-Malo",
        location: "Saint-Malo, Bretagne",
        description: "Installation de 3 systèmes de filtration autonome pour la dépollution du port historique",
        results: ["Eau clarifiée à 95%", "Biodiversité marine retrouvée", "Réduction de 80% des plastiques"],
        image: "https://images.unsplash.com/photo-1693777447721-311ee1cf2b57",
        year: "2024"
      },
      {
        id: 2,
        name: "Canal de Digoin",
        location: "Digoin, Bourgogne",
        description: "Système de phytoremédiation pour le traitement des nutriments en excès",
        results: ["Nitrates réduits de 90%", "Prolifération algale contrôlée", "Écosystème restauré"],
        image: "https://images.unsplash.com/photo-1533077162801-86490c593afb",
        year: "2023"
      },
      {
        id: 3,
        name: "Bassin urbain de Toul",
        location: "Toul, Grand Est",
        description: "Dépollution complète d'un bassin urbain avec technologies hybrides",
        results: ["Hydrocarbures éliminés", "Qualité baignade retrouvée", "Faune aquatique diversifiée"],
        image: "https://images.unsplash.com/photo-1681815065532-21343203087a",
        year: "2024"
      }
    ]
  },

  // Contact information
  contact: {
    email: "Utilisez le formulaire juste au dessus 👆",
    phone: "Parlez au formulaire au dessus de juste au dessus 👆👆",
    address: "4 rue du Général Roux, 77590, FOntaine-le-Port",
    socialMedia: {
      linkedin: "https://linkedin.com/company/good-bloom",
      youtube: "https://youtube.com/good-bloom"
    }
  },

  // Chatbot initial messages
  chatbot: {
    welcomeMessage: "Bonjour ! Je suis l'assistant Good-Bloom. Comment puis-je vous aider avec vos besoins en dépollution aquatique ?",
    quickReplies: [
      "Demander un devis",
      "Prendre rendez-vous",
      "En savoir plus sur nos technologies",
      "Voir nos réalisations"
    ]
  },

  // Appointment booking data
  appointments: {
    calendlyUrl: "https://calendly.com/mathieuwelsch/30min",
    availableSlots: [
      { date: "2024-01-15", time: "09:00" },
      { date: "2024-01-15", time: "14:00" },
      { date: "2024-01-16", time: "10:30" },
      { date: "2024-01-16", time: "16:00" }
    ]
  }
};

// Mock form submissions
export const mockFormSubmission = (formData) => {
  return new Promise((resolve) => {
    setTimeout(() => {
      console.log('Form submitted:', formData);
      resolve({
        success: true,
        message: "Merci ! Nous reviendrons vers vous sous 24h."
      });
    }, 1000);
  });
};

// Mock chatbot responses
export const mockChatbotResponse = (message) => {
  return new Promise((resolve) => {
    setTimeout(() => {
      const responses = {
        "devis": "Je peux vous orienter vers nos solutions. Quel type d'environnement aquatique souhaitez-vous traiter ?",
        "rendez-vous": "Parfait ! Je vais vous rediriger vers notre calendrier de prise de rendez-vous.",
        "technologies": "Nos technologies incluent la filtration des plastiques, le traitement des nutriments et l'absorption des hydrocarbures. Souhaitez-vous plus de détails ?",
        "réalisations": "Nous avons mené des projets à Saint-Malo, Digoin et Toul. Lequel vous intéresse ?"
      };
      
      const lowercaseMessage = message.toLowerCase();
      let response = "Je comprends votre demande. Un de nos experts va vous recontacter pour vous fournir des informations personnalisées.";
      
      for (const [key, value] of Object.entries(responses)) {
        if (lowercaseMessage.includes(key)) {
          response = value;
          break;
        }
      }
      
      resolve(response);
    }, 800);
  });
};